import { createAction } from 'redux-actions';

const setPeriod = createAction('profile--setPeriod', (id) => ({ id }));

const statisticActions = {
  setPeriod,
};

export default statisticActions;
